import { ContentState } from "draft-js";
import { TextSection } from "@domain/lms/article/article";
import { SectionController } from "@ui/pages/lms/article/articleEditorPage/sectionEditor/sectionController";
export class TextSectionController extends SectionController<TextSection> {
	setContent(content: ContentState): void {
		this.sectionUpdater((section) => ({ ...section, content }));
	}
}
